import { Button, Stack, Typography } from '@mui/material';
import { GenericDialog } from '@/components/shared/GenericDialog';
import { abyssColors } from '@/theme/colors';

type Props = {
  openTimeModal: boolean;
  closeTimeModal: () => void;
};

export const StartZoneConfirmationDialog = ({ openTimeModal, closeTimeModal }: Props) => {
  return (
    <GenericDialog
      open={openTimeModal}
      dialogStyles={{
        '.MuiDialog-container': {
          alignItems: 'baseline',
          paddingTop: '14.8rem',
        },
        '.MuiDialogContent-root': {
          padding: '0 2.4rem',
        },
      }}
      paperStyles={{
        maxWidth: '52.6rem',
      }}
      titleStyles={{
        padding: '2.4rem 2.4rem 0.8rem 2.4rem',
        fontSize: '2rem',
        fontWeight: 500,
      }}
      onClose={closeTimeModal}
      title="Time tracking"
      content={
        <Stack>
          <Typography
            fontSize="1.4rem"
            color={abyssColors.primary[700]}
            lineHeight={1.43}
            letterSpacing="normal"
          >
            We have started the tracking of your work time. After 2 minutes of inactivity, idle time
            will be recorded. To pause tracking, simply close the tab.
          </Typography>
        </Stack>
      }
      actions={
        <Stack
          direction="row"
          sx={{
            '.MuiButton-root': {
              padding: '0.6rem 1.6rem',
              textTransform: 'uppercase',
              fontWeight: 500,
              lineHeight: '2.4rem',
              letterSpacing: '0.04rem',
              fontSize: '1.4rem',
            },
          }}
        >
          <Button variant="contained" sx={{ fontWeight: 500 }} onClick={closeTimeModal}>
            OK, I UNDERSTAND
          </Button>
        </Stack>
      }
      actionsStyles={{ padding: '2.4rem', paddingTop: '3.2rem' }}
    />
  );
};
